import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { AppInfoService } from '../../../shared/services/general';

@Component({
  selector: 'app-empty-layout-footer',
  templateUrl: './empty-layout-footer.component.html',
  styleUrls: ['./empty-layout-footer.component.scss']
})
export class EmptyLayoutFooterComponent {
    constructor(public applicationInfo: AppInfoService) {
    }

    get Year() {
        return moment().year();
    }
}
